// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .color-accent {
  color: var(--accent) !important;
}
::ng-deep .color-primary {
  color: #004d00 !important;
}
::ng-deep .color-red {
  color: #d32f2f !important;
}
::ng-deep .text-align-left {
  text-align: left !important;
}
::ng-deep .header {
  padding: 0.25rem 1rem;
  background: linear-gradient(90deg, #008000, #004d00);
  position: sticky;
  top: 0;
}
::ng-deep .header a.navbar-brand {
  padding: 0;
}
::ng-deep .header a.navbar-brand img {
  height: 62px;
}
::ng-deep .customer-supplier-wrapper,
::ng-deep .requested-products-wrapper,
::ng-deep .recommended-products-wrapper {
  background: white;
  display: flex;
  flex: 1;
  flex-direction: column;
}
::ng-deep .customer-supplier-wrapper span, ::ng-deep .customer-supplier-wrapper div, ::ng-deep .customer-supplier-wrapper a,
::ng-deep .requested-products-wrapper span,
::ng-deep .requested-products-wrapper div,
::ng-deep .requested-products-wrapper a,
::ng-deep .recommended-products-wrapper span,
::ng-deep .recommended-products-wrapper div,
::ng-deep .recommended-products-wrapper a {
  color: var(--accent);
}
::ng-deep .customer-supplier-wrapper {
  background: #f0f0f0;
}
::ng-deep .customer-supplier-wrapper .customer-supplier-details {
  display: flex;
  flex: 1;
  flex-direction: row;
  padding: 2rem 0;
}
::ng-deep .customer-supplier-wrapper .customer-supplier-details .supplier-details,
::ng-deep .customer-supplier-wrapper .customer-supplier-details .customer-details {
  display: flex;
  flex: 1;
  flex-direction: column;
  border-left: 4px solid var(--accent);
  padding-left: 0.5rem;
}
::ng-deep .customer-supplier-wrapper .customer-supplier-details .supplier-details a.info,
::ng-deep .customer-supplier-wrapper .customer-supplier-details .customer-details a.info {
  text-decoration: underline;
}
::ng-deep .customer-supplier-wrapper .customer-supplier-details .supplier-details a.info:hover,
::ng-deep .customer-supplier-wrapper .customer-supplier-details .customer-details a.info:hover {
  text-decoration: none;
}
::ng-deep .requested-products-wrapper {
  background: white;
}
::ng-deep .requested-product,
::ng-deep .recommended-product {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #f0f0f0 !important;
  /* Pricing Details Grid */
}
::ng-deep .requested-product .header-details,
::ng-deep .recommended-product .header-details {
  text-align: left;
  margin-bottom: 0.5rem;
}
::ng-deep .requested-product .header-details h2,
::ng-deep .recommended-product .header-details h2 {
  display: block;
  font-size: 0.9rem;
  color: #666 !important;
  margin-bottom: 0.25rem;
}
::ng-deep .requested-product .header-details p,
::ng-deep .recommended-product .header-details p {
  font-size: 1rem;
  color: #d32f2f;
  font-weight: bold;
}
::ng-deep .requested-product .header-details p.availability,
::ng-deep .recommended-product .header-details p.availability {
  text-transform: uppercase;
  display: inline-block;
  background-color: #ffeb3b;
  color: #d32f2f;
  font-size: 0.75em !important;
  border-radius: 0.25rem;
  padding: 0.1rem 0.2rem;
  margin-bottom: 0;
}
::ng-deep .requested-product .header-details a.info,
::ng-deep .recommended-product .header-details a.info {
  font-size: 0.75em !important;
  text-transform: uppercase;
  text-decoration: underline;
  background: #f0f0f0;
  margin-left: 1rem;
}
::ng-deep .requested-product .header-details a.info:hover,
::ng-deep .recommended-product .header-details a.info:hover {
  text-decoration: none;
}
::ng-deep .requested-product .pricing-details,
::ng-deep .recommended-product .pricing-details {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  text-align: center;
}
::ng-deep .requested-product .pricing-details .detail-item .label,
::ng-deep .recommended-product .pricing-details .detail-item .label {
  display: block;
  font-size: 0.9rem !important;
  color: #666;
  margin-bottom: 5px;
}
::ng-deep .requested-product .pricing-details .detail-item .value,
::ng-deep .recommended-product .pricing-details .detail-item .value {
  display: block;
  font-size: 1.2rem;
  font-weight: bold;
  color: #0056b3;
}
::ng-deep .recommended-product {
  margin-left: 1rem;
  margin-bottom: 0.25rem;
}
::ng-deep .recommended-product:last-child {
  margin-bottom: 1rem;
}
::ng-deep .recommended-products-wrapper .recommended-products-border {
  display: flex;
  flex: 1;
  border-left: 1rem solid transparent;
  border-image: linear-gradient(to right, #008000, #004d00) 1;
  border-bottom: 1rem solid transparent;
  flex-direction: column;
}
::ng-deep .hide-for-print {
  display: block;
}
::ng-deep .button-wrapper {
  padding: 1rem;
  background: #008000;
  width: -moz-fit-content;
  width: fit-content;
}
::ng-deep .button-wrapper a {
  color: white !important;
}
::ng-deep .terms-conditions-wrapper {
  background: #f0f0f0;
}
::ng-deep .terms-conditions-wrapper .terms-conditions-details {
  display: flex;
  flex: 1;
  flex-direction: row;
  padding: 0;
}
::ng-deep .terms-conditions-wrapper .terms-conditions-details .terms-conditions,
::ng-deep .terms-conditions-wrapper .terms-conditions-details .qr-code {
  display: flex;
  flex-direction: column;
  border-left: 4px solid var(--accent);
  padding: 0 0.5rem;
}
::ng-deep .terms-conditions-wrapper .terms-conditions-details .terms-conditions ul.disc,
::ng-deep .terms-conditions-wrapper .terms-conditions-details .qr-code ul.disc {
  list-style-type: disc;
  margin-bottom: 0;
}
::ng-deep .terms-conditions-wrapper .terms-conditions-details .terms-conditions ul.disc li,
::ng-deep .terms-conditions-wrapper .terms-conditions-details .qr-code ul.disc li {
  font-size: 0.8em !important;
  margin-left: 1.25rem;
  margin-bottom: 2px;
}
::ng-deep .terms-conditions-wrapper .terms-conditions-details .terms-conditions a.href-smaller,
::ng-deep .terms-conditions-wrapper .terms-conditions-details .qr-code a.href-smaller {
  font-size: 0.8em !important;
  text-decoration: underline;
}
::ng-deep .terms-conditions-wrapper .terms-conditions-details .terms-conditions a.href-smaller:hover,
::ng-deep .terms-conditions-wrapper .terms-conditions-details .qr-code a.href-smaller:hover {
  text-decoration: none;
}
::ng-deep .terms-conditions-wrapper .terms-conditions-details .terms-conditions img,
::ng-deep .terms-conditions-wrapper .terms-conditions-details .qr-code img {
  width: 180px;
  height: 180px;
}`, "",{"version":3,"sources":["webpack://./src/app/retail/quote-view/quote-view.component.scss"],"names":[],"mappings":"AACC;EACC,+BAAA;AAAF;AAGC;EACC,yBAAA;AADF;AAIC;EACC,yBAAA;AAFF;AAKC;EACC,2BAAA;AAHF;AAMC;EACC,qBAAA;EACA,oDAAA;EACA,gBAAA;EACA,MAAA;AAJF;AAOG;EACC,UAAA;AALJ;AAOI;EACC,YAAA;AALL;AAWC;;;EAGC,iBAAA;EACA,aAAA;EACA,OAAA;EACA,sBAAA;AATF;AAWE;;;;;;;EACC,oBAAA;AAHH;AAOC;EACC,mBAAA;AALF;AAOE;EACC,aAAA;EACA,OAAA;EACA,mBAAA;EACA,eAAA;AALH;AAOG;;EAEC,aAAA;EACA,OAAA;EACA,sBAAA;EACA,oCAAA;EACA,oBAAA;AALJ;AAOI;;EACC,0BAAA;AAJL;AAMK;;EACC,qBAAA;AAHN;AAUC;EACC,iBAAA;AARF;AAWC;;EAEC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,8BAAA;EA2CA,yBAAA;AAnDF;AAUE;;EACC,gBAAA;EACA,qBAAA;AAPH;AASG;;EACC,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;AANJ;AASG;;EACC,eAAA;EACA,cAAA;EACA,iBAAA;AANJ;AAQI;;EACC,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,4BAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;AALL;AASG;;EACC,4BAAA;EACA,yBAAA;EACA,0BAAA;EACA,mBAAA;EACA,iBAAA;AANJ;AAQI;;EACC,qBAAA;AALL;AAWE;;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,kBAAA;AARH;AAWI;;EACC,cAAA;EACA,4BAAA;EACA,WAAA;EACA,kBAAA;AARL;AAWI;;EACC,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AARL;AAcC;EACC,iBAAA;EACA,sBAAA;AAZF;AAcE;EACC,mBAAA;AAZH;AAiBE;EACC,aAAA;EACA,OAAA;EACA,mCAAA;EACA,2DAAA;EACA,qCAAA;EACA,sBAAA;AAfH;AAmBC;EACC,cAAA;AAjBF;AAoBC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;AAlBF;AAoBE;EACC,uBAAA;AAlBH;AAsBC;EACC,mBAAA;AApBF;AAsBE;EACC,aAAA;EACA,OAAA;EACA,mBAAA;EACA,UAAA;AApBH;AAsBG;;EAEC,aAAA;EACA,sBAAA;EACA,oCAAA;EACA,iBAAA;AApBJ;AAsBI;;EACC,qBAAA;EACA,gBAAA;AAnBL;AAqBK;;EACC,2BAAA;EACA,oBAAA;EACA,kBAAA;AAlBN;AAsBI;;EACC,2BAAA;EACA,0BAAA;AAnBL;AAqBK;;EACC,qBAAA;AAlBN;AAsBI;;EACC,YAAA;EACA,aAAA;AAnBL","sourcesContent":["::ng-deep {\n\t.color-accent {\n\t\tcolor: var(--accent) !important;\n\t}\n\n\t.color-primary {\n\t\tcolor: #004d00 !important;\n\t}\n\n\t.color-red {\n\t\tcolor: #d32f2f !important;\n\t}\n\n\t.text-align-left {\n\t\ttext-align: left !important;\n\t}\n\n\t.header {\n\t\tpadding: .25rem 1rem;\n\t\tbackground: linear-gradient(90deg, #008000, #004d00);\n\t\tposition: sticky;\n\t\ttop: 0;\n\n\t\ta {\n\t\t\t&.navbar-brand {\n\t\t\t\tpadding: 0;\n\n\t\t\t\timg {\n\t\t\t\t\theight: 62px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.customer-supplier-wrapper,\n\t.requested-products-wrapper,\n\t.recommended-products-wrapper {\n\t\tbackground: white;\n\t\tdisplay: flex;\n\t\tflex: 1;\n\t\tflex-direction: column;\n\n\t\tspan, div, a {\n\t\t\tcolor: var(--accent);\n\t\t}\n\t}\n\n\t.customer-supplier-wrapper {\n\t\tbackground: #f0f0f0;\n\n\t\t.customer-supplier-details {\n\t\t\tdisplay: flex;\n\t\t\tflex: 1;\n\t\t\tflex-direction: row;\n\t\t\tpadding: 2rem 0;\n\n\t\t\t.supplier-details,\n\t\t\t.customer-details {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex: 1;\n\t\t\t\tflex-direction: column;\n\t\t\t\tborder-left: 4px solid var(--accent);\n\t\t\t\tpadding-left: .5rem;\n\n\t\t\t\ta.info {\n\t\t\t\t\ttext-decoration: underline;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.requested-products-wrapper {\n\t\tbackground: white;\n\t}\n\n\t.requested-product,\n\t.recommended-product {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tjustify-content: space-between;\n\t\tbackground: #f0f0f0 !important;\n\n\t\t.header-details {\n\t\t\ttext-align: left;\n\t\t\tmargin-bottom: .5rem;\n\n\t\t\th2 {\n\t\t\t\tdisplay: block;\n\t\t\t\tfont-size: 0.9rem;\n\t\t\t\tcolor: #666 !important;\n\t\t\t\tmargin-bottom: .25rem;\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tfont-size: 1rem;\n\t\t\t\tcolor: #d32f2f;\n\t\t\t\tfont-weight: bold;\n\n\t\t\t\t&.availability {\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tbackground-color: #ffeb3b;\n\t\t\t\t\tcolor: #d32f2f;\n\t\t\t\t\tfont-size: 0.75em !important;\n\t\t\t\t\tborder-radius: .25rem;\n\t\t\t\t\tpadding: .1rem .2rem;\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\ta.info {\n\t\t\t\tfont-size: 0.75em !important;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\ttext-decoration: underline;\n\t\t\t\tbackground: #f0f0f0;\n\t\t\t\tmargin-left: 1rem;\n\n\t\t\t\t&:hover {\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/* Pricing Details Grid */\n\t\t.pricing-details {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: repeat(4, 1fr);\n\t\t\tgap: 1rem;\n\t\t\ttext-align: center;\n\n\t\t\t.detail-item {\n\t\t\t\t.label {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tfont-size: 0.9rem !important;\n\t\t\t\t\tcolor: #666;\n\t\t\t\t\tmargin-bottom: 5px;\n\t\t\t\t}\n\n\t\t\t\t.value {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tfont-size: 1.2rem;\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\tcolor: #0056b3;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.recommended-product {\n\t\tmargin-left: 1rem;\n\t\tmargin-bottom: .25rem;\n\n\t\t&:last-child {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\t}\n\n\t.recommended-products-wrapper {\n\t\t.recommended-products-border {\n\t\t\tdisplay: flex;\n\t\t\tflex: 1;\n\t\t\tborder-left: 1rem solid transparent;\n\t\t\tborder-image: linear-gradient(to right, #008000, #004d00) 1;\n\t\t\tborder-bottom: 1rem solid transparent;\n\t\t\tflex-direction: column;\n\t\t}\n\t}\n\n\t.hide-for-print {\n\t\tdisplay: block;\n\t}\n\n\t.button-wrapper {\n\t\tpadding: 1rem;\n\t\tbackground: #008000;\n\t\twidth: fit-content;\n\n\t\ta {\n\t\t\tcolor: white !important;\n\t\t}\n\t}\n\n\t.terms-conditions-wrapper {\n\t\tbackground: #f0f0f0;\n\n\t\t.terms-conditions-details {\n\t\t\tdisplay: flex;\n\t\t\tflex: 1;\n\t\t\tflex-direction: row;\n\t\t\tpadding: 0;\n\n\t\t\t.terms-conditions,\n\t\t\t.qr-code {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tborder-left: 4px solid var(--accent);\n\t\t\t\tpadding: 0 .5rem;\n\n\t\t\t\tul.disc {\n\t\t\t\t\tlist-style-type: disc;\n\t\t\t\t\tmargin-bottom: 0;\n\n\t\t\t\t\tli {\n\t\t\t\t\t\tfont-size: .8em !important;\n\t\t\t\t\t\tmargin-left: 1.25rem;\n\t\t\t\t\t\tmargin-bottom: 2px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\ta.href-smaller {\n\t\t\t\t\tfont-size: .8em !important;\n\t\t\t\t\ttext-decoration: underline;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\timg {\n\t\t\t\t\twidth: 180px;\n\t\t\t\t\theight: 180px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
